import React, { useRef } from 'react';
import dayjs from 'dayjs';
import useForm from 'components/use-form';
import QualificationInfoEdit from 'pages/regist/formComponent/QualifyInfo';
import { QualificationInfo } from 'model/agency';
import { AgencyDetailProps } from '../../use-agency-detail';
import { qualificationFormConfig } from '../config';

const QualificationInfo: React.FC<AgencyDetailProps> = (props) => {
  const formRef = useRef<any>();
  const data = props.data?.qualification_management_info as QualificationInfo;

  const { Form } = useForm({
    data,
    mode: 'text',
    title: '资质信息',
    config: qualificationFormConfig,
    EditComponent: QualificationInfoEdit,
    editProps: {
      initData: {
        ...(data || {}),
        company_certification: data?.company_certification?.[0]?.image_url,
        company_owner_idfront: data?.company_owner_id_pic?.[0]?.image_url,
        company_owner_idback: data?.company_owner_id_pic?.[1]?.image_url,
        icp_no: data?.icp_no.split(',').map((item) => ({ file_url: item })),
      },
      ref: formRef,
    },
    onSubmit: async (editClose) => {
      const formData = formRef?.current?.submit?.();
      if (!formData) return;
      const data = {
        ...formData,
        company_owner_id_pic: [
          { image_url: formData.company_owner_idfront },
          { image_url: formData.company_owner_idback },
        ],
        company_certification: [{ image_url: formData.company_certification }],
        company_expiretime: dayjs(formData.company_expiretime).format('YYYY-MM-DD 00:00:00'),
        icp_no: formData.icp_no.map((item: { url: string }) => item.url).join(','), // 应需求改动，调整 icp_no ICP 证件号格式
      };
      const isSuccess = await props.onUpdate({ qualification_management_info: data });
      if (isSuccess) {
        editClose();
      }
    },
  });

  return Form;
};

export default QualificationInfo;
